import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as button from '../../button'

@ngCore.Component({
  imports: [button.Component],
  selector: 'atn-ds-initial-state',
  standalone: true,
  styleUrls: ['./initial-state.component.scss'],
  templateUrl: './initial-state.component.html',
})
export class AtnDsInitialStateComponent {
  /** TODO: js doc */
  public readonly appTitleSg = ngCore.input<string | undefined>(undefined, {
    alias: 'appTitle',
  })
  /** TODO: js doc */
  public readonly appDescriptionSg = ngCore.input<string | undefined>(
    undefined,
    {
      alias: 'appDescription',
    },
  )
  /**
   * If no id is provided, a generic illustration will be used to serve a
   * general purpose.
   */
  public readonly appIdSg = ngCore.input<ents.core.admin.App.Id | undefined>(
    undefined,
    {
      alias: 'appId',
    },
  )
  /** TODO: js doc */
  public btnTextSg = ngCore.input<string | undefined>('Create Scenario', {
    alias: 'btnText',
  })
  /** TODO: js doc */
  public btnDescriptionSg = ngCore.input<string | undefined>(
    'Click Create Scenario to start!',
    { alias: 'btnDescription' },
  )

  /** TODO: js doc */
  @ngCore.Output()
  public action = new ngCore.EventEmitter<void>()
  /** TODO: should somehow pull proper image from passed {@link AtnDsInitialStateComponent.appIdSg} */
  public graphicImageUrlSg = ngCore.computed(
    () => 'assets/img/initial-state-space-graphic.png',
  )
  /** TODO: should somehow pull proper image from passed {@link AtnDsInitialStateComponent.appIdSg} */
  public sceneImageUrlSg = ngCore.computed(
    () => 'assets/img/initial-state-space-scene.png',
  )
}
